import axios from 'axios'
import config from '../config'

const service = axios.create({
  baseURL: config.apiUrl,
  timeout: config.timeout,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code && res.code !== 200) {
      console.error('Response error:', res.message || 'Unknown error')
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  error => {
    console.error('Network error:', error.message)
    return Promise.reject(error)
  }
)

export default service

// ==================== 公开 API ====================
const publicBase = '/public'

// Banner
export const getBanners = (params) => service.get(`${publicBase}/banners`, { params })

// Categories
export const getCategories = (params) => service.get(`${publicBase}/categories`, { params })

// Articles
export const getArticles = (params) => service.get(`${publicBase}/articles`, { params })
export const getArticleDetail = (id) => service.get(`${publicBase}/articles/${id}`)

// Notices
export const getNotices = () => service.get(`${publicBase}/notices`)

// Videos
export const getVideos = (params) => service.get(`${publicBase}/videos`, { params })
export const getVideoCategories = () => service.get(`${publicBase}/video-categories`)

// Experts
export const getExperts = () => service.get(`${publicBase}/experts`)

// Locations
export const getLocations = () => service.get(`${publicBase}/locations`)

// Site Configs
export const getSiteConfigs = (params) => service.get(`${publicBase}/configs`, { params })

// Pages
export const getPageBySlug = (slug) => service.get(`${publicBase}/pages/${slug}`)
export const getPages = () => service.get(`${publicBase}/pages`)

// Navigations
export const getNavigations = (params) => service.get(`${publicBase}/navigations`, { params })

// Channel Headers (考试频道头图)
export const getChannelHeaders = (slug) => service.get(`${publicBase}/channel-headers`, { params: { slug } })

// Channel Categories (考试频道分类带文章)
export const getChannelCategories = (params) => service.get(`${publicBase}/channel-categories`, { params })

// Products
export const getProducts = (params) => service.get(`${publicBase}/products`, { params })
export const getProductDetail = (id) => service.get(`${publicBase}/products/${id}`)

// Books
export const getBooks = (params) => service.get(`${publicBase}/books`, { params })
export const getBookDetail = (id) => service.get(`${publicBase}/books/${id}`)
